import { useMemo } from 'react';
import type { Event } from '../interfaces/Calendar.model';

export const useCalendarEvents = (
    events: Event[],
    startOfTimeFrame: Date,
    endOfTimeFrame: Date
) => {
    return useMemo(
        () =>
            events
                .map((event) => ({
                    ...event,
                    startDate: new Date(event.startDate),
                    endDate: new Date(event.endDate),
                }))
                .filter(
                    (event) =>
                        (event.startDate >= startOfTimeFrame &&
                            event.startDate <= endOfTimeFrame) ||
                        (event.endDate >= startOfTimeFrame && event.endDate <= endOfTimeFrame)
                ),
        [events, startOfTimeFrame, endOfTimeFrame]
    );
};
